/**
 * Products Bundle Web Component - Sleek Theme OS 2.0
 */
if (!customElements.get('products-bundle')) {
  class ProductsBundle extends HTMLElement {
    constructor() {
      super();
      this.cssClasses = {
        hover: 'is-hover',
        active: 'is-active'
      };
    }

    connectedCallback() {
      this.cards = Array.from(this.querySelectorAll('.product-bundle-card'));
      this.hotspots = Array.from(this.querySelectorAll('.product-bundle-hotspot'));
      this.addBtn = this.querySelector('.btn--bundle-add');
      this.successMsg = this.querySelector('.products-bundle__success-msg');
      this.variantSelects = Array.from(this.querySelectorAll('.product-bundle-card__variant-select'));

      this.initHotspots();
      this.initVariantSelectors();
      this.initAddToCart();
    }

    initHotspots() {
      // Mouse events for desktop
      this.hotspots.forEach((hotspot) => {
        const blockId = hotspot.dataset.blockId;
        hotspot.addEventListener('mouseenter', () => this.setActiveBlock(blockId));
        hotspot.addEventListener('mouseleave', () => this.clearActiveBlock());
        hotspot.addEventListener('click', (e) => {
          e.preventDefault();
          this.setActiveBlock(blockId);
        });
      });

      this.cards.forEach((card) => {
        const blockId = card.dataset.blockId;
        card.addEventListener('mouseenter', () => this.setActiveBlock(blockId));
        card.addEventListener('mouseleave', () => this.clearActiveBlock());
      });
    }

    setActiveBlock(blockId) {
      if (!blockId) return;
      this.classList.add(this.cssClasses.hover);

      this.hotspots.forEach((h) => {
        if (h.dataset.blockId === blockId) {
          h.classList.add(this.cssClasses.active);
        } else {
          h.classList.remove(this.cssClasses.active);
        }
      });

      this.cards.forEach((c) => {
        if (c.dataset.blockId === blockId) {
          c.classList.add(this.cssClasses.active);
        } else {
          c.classList.remove(this.cssClasses.active);
        }
      });
    }

    clearActiveBlock() {
      this.classList.remove(this.cssClasses.hover);
      this.hotspots.forEach((h) => h.classList.remove(this.cssClasses.active));
      this.cards.forEach((c) => c.classList.remove(this.cssClasses.active));
    }

    initVariantSelectors() {
      this.variantSelects.forEach((select) => {
        select.addEventListener('change', (e) => {
          const selectedOption = select.options[select.selectedIndex];
          const price = selectedOption.dataset.price;
          const comparePrice = selectedOption.dataset.comparePrice;
          const card = select.closest('.product-bundle-card');
          if (card && price) {
            const priceEl = card.querySelector('.product-bundle-card__price--sale');
            if (priceEl) priceEl.textContent = price;
            const compareEl = card.querySelector('.product-bundle-card__price--compare');
            if (compareEl && comparePrice) compareEl.textContent = comparePrice;
          }
        });
      });
    }

    async initAddToCart() {
      if (!this.addBtn) return;

      this.addBtn.addEventListener('click', async (e) => {
        e.preventDefault();
        const items = [];

        this.querySelectorAll('select[name="id"]').forEach((select) => {
          if (select.value) {
            items.push({
              id: parseInt(select.value, 10),
              quantity: 1
            });
          }
        });

        if (items.length === 0) return;

        this.addBtn.classList.add('is-loading');
        this.addBtn.setAttribute('disabled', 'disabled');

        try {
          // Standard Shopify AJAX Cart Add Multiple Items API
          const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            },
            body: JSON.stringify({ items })
          });

          const data = await response.json();

          if (response.ok) {
            if (this.successMsg) {
              this.successMsg.classList.add('is-visible');
              setTimeout(() => {
                this.successMsg.classList.remove('is-visible');
              }, 4000);
            }

            // Trigger global Shopify cart update events
            document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
            document.dispatchEvent(new CustomEvent('cart:updated', { detail: { data }, bubbles: true }));
            
            // Open cart drawer if present
            const cartDrawer = document.querySelector('cart-drawer');
            if (cartDrawer && typeof cartDrawer.open === 'function') {
              cartDrawer.open();
            }
          }
        } catch (err) {
          console.error('Error adding bundle to cart:', err);
        } finally {
          this.addBtn.classList.remove('is-loading');
          this.addBtn.removeAttribute('disabled');
        }
      });
    }
  }

  customElements.define('products-bundle', ProductsBundle);
}
